import { supabase } from '@/integrations/supabase/client';

const BUCKET_NAME = 'menu-item-images';

const generateFileName = (extension: string): string => {
  const ext = extension.replace(/[^a-z0-9]/gi, '').toLowerCase() || 'jpg';
  const random = typeof globalThis.crypto !== 'undefined' && typeof globalThis.crypto.randomUUID === 'function'
    ? globalThis.crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return `${random}.${ext}`;
};

export async function uploadMenuImage(file: File, tenantSlug: string): Promise<string> {
  const extension = (file.name.split('.').pop() ?? '').toLowerCase();
  const fileName = generateFileName(extension);
  const sanitizedTenant = tenantSlug?.trim() || 'general';
  const path = `${sanitizedTenant}/${fileName}`;

  const { error } = await supabase.storage
    .from(BUCKET_NAME)
    .upload(path, file, {
      cacheControl: '3600',
      upsert: false,
      contentType: file.type || undefined,
    });

  if (error) {
    throw new Error(error.message);
  }

  const { data } = supabase.storage.from(BUCKET_NAME).getPublicUrl(path);
  if (!data?.publicUrl) {
    throw new Error('Unable to resolve public URL for uploaded image.');
  }

  return data.publicUrl;
}
